/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  downloadRejectionsReport,
  getDateRange,
  getDynamicColumn,
  getItemMaster,
  getRejectionsReport,
  getSubModulesByRoleId,
} from "../../../store";

import { CSVLink } from "react-csv";

// config file
import Config from "../../../config/index";

// Cookies
import {
  Alert,
  Backdrop,
  CircularProgress,
  Collapse,
  IconButton,
  Modal,
} from "@mui/material";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import { addDays, addMinutes, format, subDays } from "date-fns";

import MDCard from "components/MDCard";
import TextError from "utils/TextError";

import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 400, md: 520 },
  maxHeight: "90vh",
  // Remove or adjust overflowY
  // overflowY: "visible",
  boxShadow: 24,
  p: 2,
  bgcolor: "background.paper",
  borderRadius: 3,
  zIndex: 1400,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const RejectionReport = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getItemMaster,
  getRejectionsReport,
  downloadRejectionsReport,
  downloadRejectionsReportReducer,
  itemMaster,

  getRejectionsReportReducer,
  getDateRange,
  getDateRangeReducer,
  getDynamicColumnReducer,

  createDynamicColumn,
  getDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  const [selectedFgType, setSelectedFgType] = useState("");
  const [selectedItemCode, setSelectedItemCode] = useState("");

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getItemMaster(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let rejectionReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "7502ad03-a573-472d-9c5e-f2c11f29c293",
  );

  // let viewRejection = rejectionReportModule
  //   ? rejectionReportModule.actionId.includes(
  //       "5be6bf79-c680-46a7-a562-945d8490727c"
  //     )
  //   : null;

  let viewRejection = true;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  // let isoStartDate;
  // let isoEndDate;
  // useEffect(() => {
  //   if (startDate || endDate) {
  //     isoStartDate = new Date(
  //       (startDate ? startDate : new Date()).getTime() -
  //         (startDate ? startDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formatDate = (date) => {
  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  //       const year = date.getFullYear();
  //       return `${day}-${month}-${year}`;
  //     };

  //     const formattedStartDate = formatDate(new Date(isoStartDate));

  //     isoEndDate = new Date(
  //       (endDate ? endDate : new Date()).getTime() -
  //         (endDate ? endDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formattedEndDate = formatDate(new Date(isoEndDate));
  //   }
  //   // Now you can use both formattedStartDate and formattedEndDate
  //   getMinMaxFailure(
  //     isoStartDate ? isoStartDate : "",
  //     isoEndDate ? isoEndDate : "",
  //     selectedItemCode?.value ? selectedItemCode?.value : "",
  //     jwtToken
  //   );
  // }, [startDate, endDate, selectedItemCode]);

  const [state, setState] = useState({
    columns: [
      { Header: "SUID", accessor: "sku", width: 320 },
      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },
      { Header: "Qty", accessor: "qty" },
      { Header: "Uom", accessor: "uom" },
      { Header: "LOT No", accessor: "lotNumber" },
      { Header: "Serial No", accessor: "serialNumber" },
      { Header: "Location", accessor: "locationCode", width: 320 },

      { Header: "first Level Rejected By", accessor: "firstLevelRejectedBy" },
      { Header: "second Level Rejected By", accessor: "secondLevelRejectedBy" },
      {
        Header: "Rejected Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getRejectionsReportReducer.trnReport.data
      ? getRejectionsReportReducer.trnReport.data
      : [];
    setPaginationObj(getRejectionsReportReducer?.trnReport?.pagination);
    setLoading(getRejectionsReportReducer.loading);
    data.map((quarantine) => {
      const formatDate = new Date(quarantine.cd);
      let des = quarantine?.itemDescription;
      let len = desLength;
      const purchaseObject = {
        privateKey: quarantine.sku,

        firstLevelRejectedBy: quarantine.firstLevelRejectedBy,
        secondLevelRejectedBy: quarantine.secondLevelRejectedBy,
        itemCode: `${quarantine.itemCode}`,
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {quarantine?.itemDescription?.length > 35 ? (
              <Tooltip
                title={quarantine.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {quarantine.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {quarantine.itemDescription}
              </MDTypography>
            )}
            {quarantine?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        sku: `${quarantine.suid ? quarantine.suid : "NA"}`,
        suid: quarantine.suid,
        itemId: quarantine.itemId,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: quarantine.cd,
        locationCode: quarantine.locationCode,
        qty: `${quarantine.qty}`,

        uom: `${quarantine.uom}`,
        // lotSerialNo: `${quarantine.lotNumber ? quarantine.lotNumber : "NA"} / ${
        //   quarantine.serialNumber ? quarantine.serialNumber : "NA"
        // }`,
        lotNumber: quarantine.lotNumber ? quarantine.lotNumber : "NA",
        serialNumber: quarantine.serialNumber ? quarantine.serialNumber : "NA",
        // isEditable: purchase.isEditable,
      };
      tempFinishedGoods.push(purchaseObject);
    });
    viewRejection && setState({ ...state, rows: tempFinishedGoods });
  }, [getRejectionsReportReducer]);

  // const [dateRangeOptions, setDateRangeOptions] = useState([]);

  // useEffect(() => {
  //   let tempItemCodeOptions = [];
  //   let data = getDateRangeReducer.dateRange.data
  //     ? getDateRangeReducer.dateRange.data
  //     : [];

  //   data.map((item) => {
  //     tempItemCodeOptions.push({
  //       label: item.value,
  //       value: item.value,
  //     });
  //   });
  //   setDateRangeOptions(tempItemCodeOptions);
  // }, [getDateRangeReducer]);

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };
  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemCode,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const handleFgTypeChange = (selectedOption) => {
    setSelectedFgType(selectedOption);
    setSelectedItemCode("");
  };

  const [downloadData, setDownloadData] = useState("");

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = downloadRejectionsReportReducer.consumptionReport.data
      ? downloadRejectionsReportReducer.consumptionReport.data
      : [];
    data.map((quarantine) => {
      const formatDate = new Date(quarantine.cd);
      let des = quarantine?.itemDescription;
      let len = desLength;
      const purchaseObject = {
        privateKey: quarantine.sku,
        itemCode: `${quarantine.itemCode}`,
        itemDescription: `${quarantine.itemDescription}`,
        sku: `${quarantine.suid ? quarantine.suid : "NA"}`,
        suid: quarantine.suid,

        firstLevelRejectedBy: quarantine.firstLevelRejectedBy,
        secondLevelRejectedBy: quarantine.secondLevelRejectedBy,
        itemId: quarantine.itemId,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: quarantine.cd,
        locationCode: quarantine.locationCode,
        qty: `${quarantine.qty}`,

        uom: `${quarantine.uom}`,
        // lotSerialNo: `${quarantine.lotNumber ? quarantine.lotNumber : "NA"} / ${
        //   quarantine.serialNumber ? quarantine.serialNumber : "NA"
        // }`,
        lotNumber: quarantine.lotNumber ? quarantine.lotNumber : "NA",
        serialNumber: quarantine.serialNumber ? quarantine.serialNumber : "NA",
      };
      tempFinishedGoods.push(purchaseObject);
    });

    setDownloadData(tempFinishedGoods);
  }, [downloadRejectionsReportReducer]);

  const [selectedDateRange, setSelectedDateRange] = useState("");

  const [customDate, setCustomDate] = useState("");
  const sevenDays = subDays(new Date(), 7).toISOString();
  const thityDays = subDays(new Date(), 30).toISOString();
  const nintyDays = subDays(new Date(), 90).toISOString();

  const [dateRange, setDateRange] = useState([null, null]);

  const [startDate, endDate] = dateRange;

  useEffect(() => {
    getDateRange(jwtToken);
  }, []);

  useEffect(() => {
    if (selectedDateRange.value == 7) {
      setCustomDate(sevenDays);
    }
    if (selectedDateRange.value == 30) {
      setCustomDate(thityDays);
    }
    if (selectedDateRange.value == 90) {
      setCustomDate(nintyDays);
    }
  }, [selectedDateRange]);

  useEffect(() => {
    getRejectionsReport(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject, refresh]);

  useEffect(() => {
    downloadRejectionsReport(
      dateRange[1] !== null
        ? addDays(dateRange[1], 1)?.toISOString()
        : new Date().toISOString(),
      dateRange[0] !== null
        ? addDays(dateRange[0], 1)?.toISOString()
        : customDate,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  }, [customDate, dateRange]);

  const handleDateRangeChange = (selected) => {
    setSelectedDateRange(selected);
  };
  const dateRangeOptions = [
    { label: "Last 7 Days", value: 7 },
    { label: "Last 30 Days", value: 30 },
    { label: "Last 3 Months", value: 90 },
    { label: "Custom date Range", value: "Custom date Range" },
  ];
  const [createCircularModal, setCreateCircularModal] = useState(false);
  const handleCreateCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(true);
    }, 500);

    setDownloadData("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
  };
  const handleCreateCloseCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(false);
    }, 500);

    setDownloadData("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
  };

  const headers = [
    { label: "SUID", key: "sku" },
    { label: "Item Code", key: "itemCode" },
    { label: "Item Description", key: "itemDescription" },
    { label: "Qty", key: "qty" },
    { label: "Uom", key: "uom" },
    { label: "LOT No", key: "lotNumber" },
    { label: "Serial No", key: "serialNumber" },
    { label: "Location", key: "locationCode" },
    { label: "First Level RejectedBy", key: "firstLevelRejectedBy" },
    { label: "Second Level RejectedBy", key: "secondLevelRejectedBy" },
    {
      label: "Rejected Date",

      key: "createdDate",
    },
  ];
  const csvLink = {
    filename: "Rejection Report.csv",
    headers: headers,
    data: downloadData,
  };

  const subModuleId = "7502ad03-a573-472d-9c5e-f2c11f29c293";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getRejectionsReport(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={0} pb={3} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox color="text" p={0} px={2} mt={0} mb={-2}>
                <DownloadDataButton
                  style={{ marginLeft: "5px", borderRadius: "5px" }}
                  size="small"
                  type="button"
                  variant="outlined"
                  color="success"
                  iconOnly
                  tooltip="Download All Data"
                  onClick={handleCreateCircularModal}
                >
                  <Icon>download</Icon>
                </DownloadDataButton>
              </MDBox>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>

              <Modal
                open={createCircularModal}
                onClose={handleCreateCloseCircularModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style} style={{ zIndex: 0 }}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Download Report
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateCloseCircularModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    {/* <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    > */}
                    <MDBox style={{ marginRight: "5px", marginBottom: "10px" }}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Date Range
                      </MDTypography>
                      <Select
                        // isClearable
                        placeholder="Choose One..."
                        className="select-css-for-filter"
                        maxMenuHeight={130}
                        options={dateRangeOptions}
                        value={selectedDateRange}
                        onChange={handleDateRangeChange}
                      />
                    </MDBox>
                    {selectedDateRange?.value === "Custom date Range" && (
                      <MDBox
                        // width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6">
                          Custom Date Range
                        </MDTypography>

                        <DatePicker
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select date range"
                          onChange={(date) => setDateRange(date)}
                          isClearable={true}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange={true}
                          popperPlacement="right-end"

                          // withPortal
                        />

                        {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                      </MDBox>
                    )}
                    {/* <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox> */}

                    <MDBox mt={3}>
                      {((selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] !== null) ||
                        selectedDateRange) &&
                        downloadData.length < 1 && (
                          <TextError msg="No data found" />
                        )}
                      {(selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] === null) ||
                      downloadData.length < 1 ||
                      !selectedDateRange ? (
                        <MDButton
                          color="success"
                          fullWidth
                          type="button"
                          disabled
                        >
                          Submit
                        </MDButton>
                      ) : (
                        <CSVLink
                          {...csvLink}
                          onClick={() => {
                            // Close modal after 2 seconds
                            setTimeout(() => {
                              handleCreateCloseCircularModal();
                            }, 1000); // 2000ms = 2 seconds
                          }}
                        >
                          <MDButton color="success" fullWidth type="button">
                            Submit
                          </MDButton>
                        </CSVLink>
                      )}
                    </MDBox>
                  </MDBox>
                  {/* </MDBox> */}
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMaster: state.itemMaster,
    getRejectionsReportReducer: state.getRejectionsReportReducer,
    downloadRejectionsReportReducer: state.downloadRejectionsReportReducer,
    getDateRangeReducer: state.getDateRangeReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getRejectionsReport: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getRejectionsReport(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    downloadRejectionsReport: (
      startDate,
      endDate,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        downloadRejectionsReport(
          startDate,
          endDate,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getDateRange: (jwtToken) => dispatch(getDateRange(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(RejectionReport);
